module.exports = __webpack_public_path__ + "img/fons-packetgrup-lateral.d614abe8.jpg";